import { CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Button as MuiButton, TextField as MuiTextField } from "@material-ui/core";
import { Archive, Cancel, Delete, Link, Unarchive, Visibility } from "@material-ui/icons";
import axios from "axios";
import RichTextInput from "ra-input-rich-text";
import { useContext, useState } from "react";
import {
    ArrayField,
    BooleanField,
    Button,
    ChipField,
    Datagrid,
    DateField,
    Edit,
    EditButton,
    EmailField, FormDataConsumer, FormTab,
    ListButton,
    ReferenceField, ReferenceInput, ReferenceManyField, SaveButton, SelectInput, TabbedForm,
    TabbedFormTabs,
    TextField,
    TextInput,
    Toolbar,
    TopToolbar,
    useNotify,
    useRedirect,
    useRefresh
} from "react-admin";
import AddNewAttachmentButton from "../../components/add-new-attachment-button";
import AttachmentDeleteButton from "../../components/attachment-delete-button";
import MaskedInput from "../../components/masked-input";
import { Spacer } from "../../components/spacer";
import { TruncatedTextField } from "../../components/truncated-text-field";
import { AppContext } from "../../providers/app-context-provider/app.context";
import cookiesProvider from "../../providers/cookies-provider";
import dataProvider from "../../providers/data-provider";
import { ProfileEnum } from "../../utils/general-profile.enum";
import { getApiUrl, getUrl } from "../../utils/urls";
import AddNewActivityButton from "./add-new-activity-button";
import AddNewPartyButton from "./add-new-party-button";
import AddNewProcessNoteButton from "./add-new-process-note-button";
import { AddRelatedProcessDialog } from "./add-related-process-dialog";
import ProcessEditAddManager from "./process-edit-add-manager";
import ProcessEditAddStudent from "./process-edit-add-student";

const ProcessEditRemoveRelated = ({ id, record, refresh, resource, ...props }) => {

    const apiUrl = getApiUrl()
    const token = cookiesProvider.getToken()

    const handleClick = async () => {
        axios.delete(
            `${apiUrl}/processes/${id}/${resource}/${record.id}`,
            { headers: { Authorization: `Bearer ${token}` } }
        ).then(() => { refresh() })
    }

    return (
        <Button label={'Remover'} onClick={handleClick}>
            <Delete />
        </Button>
    )
}

const CustomToolbar = props => {
    return <Toolbar {...props} >
        <SaveButton disabled={props.pristine} />
    </Toolbar>
}

const WarningDialog = ({ open, onClose, onAccept, ...props }) => {
    const [loading, setLoading] = useState(false)
    const [val, setVal] = useState('')
    const [valid, setValid] = useState(false)
    const handleClick = () => { setLoading(true); onAccept() }
    const onChange = (event) => {
        const newVal = event.target.value.toUpperCase();
        if (newVal === 'ARQUIVAR') {
            setValid(true)
        } else {
            setValid(false)
        }; setVal(newVal)
    }
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{`Aviso!`}</DialogTitle>
            <DialogContent>
                <DialogContentText>{`Ao arquivar este atendimento, todas as movimentações contidas nele serão marcadas como finalizadas e seus prazos não serão rastreados nos dashboards dos gestores.`}</DialogContentText>
                <DialogContentText>{`Para prosseguir com esta ação, digite "ARQUIVAR" no campo de texto abaixo.`}</DialogContentText>
                <MuiTextField variant="filled" label={'Confirmação'} value={val} onChange={onChange} fullWidth />
            </DialogContent>
            <DialogActions>
                <Button label="Cancelar" variant="contained" onClick={onClose} disabled={loading}><Cancel /></Button>
                <Spacer />
                <Button label="Prosseguir" variant="outlined" onClick={handleClick} disabled={loading || !valid}>{loading ? <CircularProgress size={16} /> : <Archive />}</Button>
            </DialogActions>
        </Dialog >
    )
}

const ProcessEdit = (props) => {

    const redirect = useRedirect()
    const refresh = useRefresh();
    const notify = useNotify()
    const context = useContext(AppContext)

    const [processTypes,] = useState([])
    const [processTypeLoading,] = useState(false)
    const [loading, setLoading] = useState(false)
    const [warningOpen, setWarningOpen] = useState(false)

    const processTypeChoices = [{ id: 'Judicial' }, { id: 'Administrativo' }, { id: 'Outros' }]

    const superAdmin = context.profile.name === ProfileEnum.SUPERADMIN

    const handleClick = () => {
        redirect(`/process-dashboard/${props.id}`)
    }

    const handleDialogOpen = () => {
        setWarningOpen(true)
    }

    const handleDialogClose = () => setWarningOpen(false)

    const handleArchiveProcess = () => {
        dataProvider.post('processes', `${props.id}/archive`, { active: true })
            .then(() => { notify('Atendimento arquivado com sucesso', 'success'); refresh() })
            .catch(() => { notify('Erro ao arquivar atendimento', 'error') })
            .finally(() => handleDialogClose())
    }

    const handleReopenProcess = () => {
        dataProvider.post('processes', `${props.id}/archive`, { active: false })
            .then(() => { notify('Atendimento reaberto com sucesso', 'success'); refresh() })
            .catch(() => { notify('Erro ao reabrir atendimento', 'error') })
            .finally(() => handleDialogClose())
    }


    const ToolbarEditWithView = ({ basePath, data }) => {
        return (
            <TopToolbar style={{ justifyContent: "flex-start" }}>
                <ListButton basePath={basePath} label={'Voltar'} />
                <Button onClick={handleClick} label={'Dashboard'}>
                    <Visibility />
                </Button>
                {
                    data?.active ? (
                        <>
                            <Button onClick={handleDialogOpen} label={'Arquivar atendimento'}>
                                <Archive />
                            </Button>
                            <WarningDialog open={warningOpen} onClose={handleDialogClose} onAccept={handleArchiveProcess} />
                        </>
                    )
                        :
                        <Button onClick={handleReopenProcess} label={"Reabrir atendimento"}>
                            {loading ? <CircularProgress size={16} /> : <Unarchive />}
                        </Button>
                }
                <div style={{ flexGrow: 1 }}></div>
                {context.profile.name === ProfileEnum.GENERAL_LAWYER && (
                    <Button
                        color={'primary'}
                        onClick={() => {
                            redirect(`/service-requests/${data.serviceRequest.id}`)
                        }}
                        label='Pedido de atendimento'>
                        <Visibility />
                    </Button>
                )}
            </TopToolbar>
        )
    }

    const CustomTitle = ({ record }) => {
        return <span> Atendimento {record ? `${record.alias}` : ''}</span>
    }

    const ViewFileButton = (props) => {
        return <Button onClick={() => { window.open(props.record.path) }} label={'Visualizar'} />
    }

    const handleRemoveUser = (processId, userId) => {
        setLoading(true)
        dataProvider.delete(`processes/${processId}/user`, { id: userId })
            .then(() => { refresh(); setLoading(false); setTimeout(() => { }, 2000) })
    }

    const handleRemoveStudent = (processId, userId) => {
        setLoading(true)
        dataProvider.delete(`processes/${processId}/student`, { id: userId })
            .then(() => { refresh(); setLoading(false); setTimeout(() => { }, 2000) })
    }

    const deleteAttachment = (processId, attachmentId) => {
        dataProvider.delete(`attachments/processes/${processId}`, { id: attachmentId })
            .then(() => { refresh(); setTimeout(() => { }, 2000) })
    }

    const ProcessNoteButton = ({ origin, record, ...props }) => {
        const redirect = useRedirect()
        const handleRedirect = () => redirect(`/student-process-notes/${record.id}`, undefined, undefined, undefined, { origin: origin })
        return <MuiButton onClick={handleRedirect} color='primary' variant="contained" size='small' > Visualizar todas</MuiButton >
    }

    const CustomQuillComponent = ({ source, label, readOnly, ...props }) => {
        return <RichTextInput source={source} label={label} fullWidth options={{ readOnly: readOnly }} {...props} />
    }

    return (
        <Edit
            mutationMode="pessimistic"
            {...props}
            actions={<ToolbarEditWithView />}
            title={<CustomTitle />}
        >
            <TabbedForm redirect='edit' toolbar={<CustomToolbar />} tabs={<TabbedFormTabs variant="scrollable" scrollButtons="on" style={{ minWidth: 0 }} />}>
                <FormTab label={'Dados Gerais'}>
                    <TextInput source="alias" label={'Protocolo'} fullWidth disabled />

                    <BooleanField source="active" label="Em aberto" />

                    <FormDataConsumer>
                        {({ formData, ...rest }) => {
                            return <CustomQuillComponent source="synthesis" label={'Síntese do atendimento'} readOnly={!formData.active} />
                        }}
                    </FormDataConsumer>
                </FormTab>
                <FormTab label={'Processo'}>
                    <Grid container>
                        <Grid item style={{ marginRight: '10px' }}>
                            <SelectInput label={'Tipo'} source={'type.type'} optionText={'id'} choices={processTypeChoices} fullWidth />
                        </Grid>
                        <Grid item style={{ flexGrow: 1 }}>
                            <FormDataConsumer>
                                {({ formData, ...rest }) => {
                                    return (
                                        <>
                                            <ReferenceInput
                                                source="type.id"
                                                label={'Tipo do processo'}
                                                reference="process-types"
                                                filter={{ type: formData.type?.type }}
                                                fullWidth
                                            >
                                                <SelectInput source='name' fullWidth />
                                            </ReferenceInput>
                                        </>
                                    )
                                }}
                            </FormDataConsumer>
                        </Grid>
                    </Grid>
                    <FormDataConsumer>
                        {({ formData, ...rest }) => {
                            if (!processTypeLoading && processTypes.find(item => item.id === formData['type'])?.pje)
                                return <MaskedInput label='Número do processo' onlyNumbers={false} source='legal_process_code' mask={'0000000-00.0000.000.0000'} fullWidth />
                            else {
                                return <TextInput source="legal_process_code" label={'Número do processo'} fullWidth />
                            }
                        }}
                    </FormDataConsumer>
                </FormTab>
                <FormTab label={'Íntegra'} path="record" >
                    <ReferenceManyField filter={{ record: true }} fullWidth reference='attachments' target='processId' label={'Íntegra do processo'}>
                        <Datagrid>
                            <TextField source={'name'} label={'Nome'} />
                            <ViewFileButton />
                            <FormDataConsumer>
                                {
                                    ({ formData, record, ...rest }) => formData?.active && (
                                        <Button style={{ color: 'red' }} label="Remover" onClick={() => deleteAttachment(formData.id, record.id)} startIcon={<Delete />}></Button>
                                    )
                                }
                            </FormDataConsumer>
                        </Datagrid>
                    </ReferenceManyField>
                    <FormDataConsumer>
                        {
                            ({ formData, ...rest }) =>
                                formData?.active &&
                                <AddNewAttachmentButton
                                    record={formData}
                                    resource="processes"
                                    refresh={refresh}
                                    multiple={true}
                                    isRecord={true}
                                    fileSize={30000000}
                                />
                        }
                    </FormDataConsumer>
                </FormTab>
                <FormTab label={'Cliente'}>
                    <TextInput source='client.name' label={'Nome'} disabled fullWidth />
                    <TextInput source='client.email' label={'Email'} disabled fullWidth />
                    <TextInput source='client.phone' label={'Telefone'} disabled fullWidth />
                </FormTab>
                <FormTab label={'Partes'} path="parties">
                    <ArrayField fullWidth source="parties" label={'Partes'}>
                        <Datagrid>
                            <TextField source='name' label={'Nome'} fullWidth />
                            <TextField source='email' label={'Email'} fullWidth />
                            <TextField source='phone' label={'Telefone'} fullWidth />
                            <TextField source="type.name" />
                            <BooleanField source='isRepresented' label={'Representado pelo NPJ?'} fullWidth />
                            <FormDataConsumer>
                                {
                                    ({ formData, ...rest }) => formData?.active && <EditButton />
                                }
                            </FormDataConsumer>
                        </Datagrid>
                    </ArrayField>
                    <FormDataConsumer>
                        {
                            ({ formData, ...rest }) => formData?.active && <AddNewPartyButton record={formData} refresh={refresh} />
                        }
                    </FormDataConsumer>
                </FormTab>
                {
                    (superAdmin || !['Professor', 'Advogado'].includes(context.profile.name)) &&
                    <FormTab label={'Gestores'} path="managed_by">

                        <ArrayField source="managed_by" label="Gestores" fullWidth>
                            <Datagrid>
                                <TextField source='user.name' label={'Nome'} fullWidth />
                                <TextField source='profile.name' label={'Perfil'} fullWidth />
                                <BooleanField source="active" label={'Ativo?'} fullWidth />
                                <EmailField source='user.email' label={'Email'} fullWidth />
                                <FormDataConsumer>
                                    {
                                        ({ formData, record, ...rest }) => formData?.active && <>
                                            <Button label="Remover"
                                                onClick={() => handleRemoveUser(formData.id, record.id)}
                                                disabled={loading}
                                                startIcon={loading ? <CircularProgress size={16} /> : <Delete />} />
                                        </>
                                    }
                                </FormDataConsumer>
                            </Datagrid>
                        </ArrayField>
                        <FormDataConsumer>
                            {
                                ({ formData, record, ...rest }) => formData?.active && (
                                    <ProcessEditAddManager
                                        record={record}
                                        resource={'processes'}
                                        path={'user'}
                                        title={`Adicionar gestores ao atendimento ${record.alias}`}
                                        refresh={refresh}
                                    />
                                )
                            }
                        </FormDataConsumer>
                    </FormTab>
                }
                <FormTab label={'Alunos'} path="students">
                    <ArrayField source="allocated_students" label="Alunos" fullWidth>
                        <Datagrid>
                            <TextField source='user.name' label={'Nome'} fullWidth />
                            <EmailField source='user.email' label={'Email'} fullWidth />
                            <BooleanField source="active" label={'Ativo?'} fullWidth />
                            <FormDataConsumer>
                                {({ formData, record, ...rest }) => formData?.active && context.profile.name !== ProfileEnum.GENERAL_LAWYER && (
                                    <Button
                                        label="Remover"
                                        onClick={() => handleRemoveStudent(formData.id, record.id)}
                                        disabled={loading}
                                        startIcon={loading ? <CircularProgress size={16} /> : <Delete />} />
                                )}
                            </FormDataConsumer>
                        </Datagrid>
                    </ArrayField>
                    <FormDataConsumer>
                        {({ formData, record, ...rest }) => formData?.active && context.profile.name !== ProfileEnum.GENERAL_LAWYER && (
                            <ProcessEditAddStudent
                                record={record}
                                resource={'processes'}
                                path={'student'}
                                title={`Adicionar alunos ao atendimento ${record.alias}`}
                                refresh={refresh}
                            />)}
                    </FormDataConsumer>
                </FormTab>
                <FormTab label={'Notas'} path="notes">
                    <ReferenceManyField fullWidth reference="process-notes" target="process.id" label={'Notas de atendimento'}>
                        <Datagrid>
                            <ReferenceField label={'Autor'} link={false} source="author.id" reference="users">
                                <TextField source="name" />
                            </ReferenceField>
                            <TruncatedTextField source={'text'} label={'Conteúdo'} />
                            <DateField source="created_at" label={'Criado em'} />
                        </Datagrid>
                    </ReferenceManyField>
                    <FormDataConsumer>
                        {({ formData, record, ...rest }) => {
                            const editable = record.active
                            return (
                                <>
                                    <AddNewProcessNoteButton origin={'processes'} record={formData} disabled={!editable} />
                                    <span style={{ marginLeft: '5px' }} />
                                    <ProcessNoteButton origin={`/processes/${record.id}/notes`} record={record} />
                                </>
                            )
                        }}
                    </FormDataConsumer>
                </FormTab>
                <FormTab label={'Anexos'} path="attachments" >
                    <ReferenceManyField filter={{ record: false }} fullWidth reference='attachments' target='processId' label={'Anexos'}>
                        <Datagrid>
                            <TextField source={'name'} label={'Nome'} />
                            <ViewFileButton />
                            <FormDataConsumer>
                                {({ formData, record, ...rest }) =>
                                    formData?.active &&
                                    <AttachmentDeleteButton path='processes' resource={'attachments'} relatedId={formData.id} record={record} undoable={false} redirect={false} />
                                }
                            </FormDataConsumer>
                        </Datagrid>
                    </ReferenceManyField>
                    <FormDataConsumer>
                        {({ formData, ...rest }) =>
                            formData?.active &&
                            <AddNewAttachmentButton record={formData} resource="processes" refresh={refresh} multiple={true} />
                        }
                    </FormDataConsumer>
                </FormTab>
                <FormTab label={'Movimentações'} path="activities">
                    <ArrayField fullWidth source="activities" label={'Movimentações'}>
                        <Datagrid>
                            <ChipField size="small" source='type.name' label={'Tipo'} fullWidth />
                            <DateField source='start_at' locales={'pt-BR'} label={'Data de início'} fullWidth />
                            <DateField source='deadline' locales={'pt-BR'} label={'Data de término'} fullWidth />
                            <BooleanField source='evaluated' label={'Corrigida'} />
                            <BooleanField source='finished' label={'Finalizada'} />
                            <EditButton />
                        </Datagrid>
                    </ArrayField>
                    <FormDataConsumer>
                        {({ formData, ...rest }) =>
                            formData?.active &&
                            <AddNewActivityButton record={formData} refresh={refresh} />
                        }
                    </FormDataConsumer>
                </FormTab>
                <FormTab label={'Processos conexos'}>
                    <ArrayField source='related' label={'Processos conexos'} fullWidth>
                        <Datagrid>
                            <TextField source="alias" label='Protocolo' />
                            <TextField source='legal_process_code' label='Código processo' />
                            <TextField source="client.name" label='Cliente' />

                            <FormDataConsumer>
                                {
                                    ({ formData, record, ...rest }) => formData?.active && <    >
                                        <Button href={`${getUrl()}/#/process-dashboard/${record.id}`} target={'_blank'} label="Visualizar">
                                            <Link />
                                        </Button>
                                    </>
                                }
                            </FormDataConsumer>
                            <FormDataConsumer>
                                {
                                    ({ formData, record, ...rest }) => formData?.active && <>
                                        <ProcessEditRemoveRelated id={formData.id} resource={'related'} record={record} refresh={refresh} />                                    </>
                                }
                            </FormDataConsumer>
                        </Datagrid>
                    </ArrayField>
                    <FormDataConsumer>
                        {({ formData, ...rest }) =>
                            formData?.active &&
                            <AddRelatedProcessDialog process={formData} refresh={refresh} />
                        }
                    </FormDataConsumer>
                </FormTab>
            </TabbedForm>
        </Edit >
    )
}

export default ProcessEdit;